import Icon, { IconProps } from '@meettry/ui-components/components/atoms/Icon/Icon';
export default Icon;
export type IconPropsType = IconProps;
